export default __webpack_public_path__ + "static/media/cote.105508c1.svg";